import { apiSlice } from './apiSlice'

export interface Memorial {
  id: string
  case_id: string
  team_id: string
  file_url: string
  file_name: string
  file_size: number
  title?: string
  version?: number
  submitted_at?: string
  status: string
  storage_path?: string
  tags?: string[]
}

export interface MemorialCreate {
  case_id: string
  team_id: string
  file: File
  title?: string
  version?: number
}

export const memorialsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMemorials: builder.query<Memorial[], { case_id?: string; team_id?: string }>({
      query: (params) => ({
        url: '/memorials/list',
        params,
      }),
      providesTags: ['Memorial'],
    }),
    getMemorial: builder.query<Memorial, string>({
      query: (id) => `/memorials/${id}`,
      providesTags: (result, error, id) => [{ type: 'Memorial', id }],
    }),
    submitMemorial: builder.mutation<Memorial, FormData>({
      query: (formData) => ({
        url: '/memorials/create',
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Memorial'],
    }),
    downloadMemorial: builder.query<Blob, string>({
      query: (id) => ({
        url: `/memorials/${id}/download`,
        responseHandler: (response: Response) => response.blob(),
      }),
    }),
    deleteMemorial: builder.mutation<{ message: string }, string>({
      query: (id) => ({
        url: `/memorials/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Memorial'],
    }),
  }),
})

export const {
  useGetMemorialsQuery,
  useGetMemorialQuery,
  useSubmitMemorialMutation,
  useLazyDownloadMemorialQuery,
  useDeleteMemorialMutation,
} = memorialsApi
